import { domReady } from "../utils";

// app/assets/javascripts/notifications_wa.js
const initNotificationsWa = () => {
  // ====================================
  // DUAL LISTBOX CUSTOMIZADO
  // ====================================

  const availableList = $('#available_users');
  const selectedList = $('#selected_users');
  const hiddenSelect = $('#user_ids_select');

  if (availableList.length && selectedList.length && hiddenSelect.length) {
    // Estado dos usuários selecionados
    let selectedUsers = new Set();

    // Inicializa com usuários já selecionados (edit)
    hiddenSelect.find('option:selected').each(function () {
      selectedUsers.add($(this).val());
    });

    // Move usuários pré-selecionados para a lista de selecionados
    selectedUsers.forEach(userId => {
      const userItem = availableList.find(`[data-user-id="${userId}"]`);
      if (userItem.length) {
        moveToSelected(userItem);
      }
    });

    // Função para mover item para selecionados
    function moveToSelected(userItem) {
      const userId = userItem.data('user-id').toString();
      const clone = userItem.clone();

      // Ajusta o checkbox
      const checkbox = clone.find('.user-checkbox-available');
      checkbox.removeClass('user-checkbox-available')
        .addClass('user-checkbox-selected')
        .prop('checked', false)
        .attr('id', 'selected_user_' + userId);

      clone.find('label').attr('for', 'selected_user_' + userId);

      selectedList.append(clone);
      userItem.hide();
      selectedUsers.add(userId);
      updateHiddenSelect();
      updateCounts();
    }

    // Função para mover item de volta para disponíveis
    function moveToAvailable(userItem) {
      const userId = userItem.data('user-id').toString();
      const originalItem = availableList.find(`[data-user-id="${userId}"]`);

      if (originalItem.length) {
        originalItem.show();
        originalItem.find('.user-checkbox-available').prop('checked', false);
      }

      userItem.remove();
      selectedUsers.delete(userId);
      updateHiddenSelect();
      updateCounts();
    }

    // Atualiza o select hidden
    function updateHiddenSelect() {
      hiddenSelect.find('option').each(function () {
        $(this).prop('selected', selectedUsers.has($(this).val()));
      });
    }

    // Atualiza contadores
    function updateCounts() {
      const availableCount = availableList.children(':visible').length;
      const selectedCount = selectedList.children().length;

      $('#available_count').text(availableCount);
      $('#selected_count').text(selectedCount);
    }

    // Filtros
    function applyFilters() {
      const roleFilter = $('#filter_role').val();
      const dealerFilter = $('#filter_dealer').val();
      const nameFilter = $('#filter_name').val().toLowerCase();

      availableList.children().each(function () {
        const item = $(this);
        const matchRole = !roleFilter || item.data('role') === roleFilter;
        const matchDealer = !dealerFilter || item.data('dealer-id') == dealerFilter;
        const matchName = !nameFilter || item.data('name').includes(nameFilter);

        if (selectedUsers.has(item.data('user-id').toString())) {
          item.hide();
        } else {
          item.toggle(matchRole && matchDealer && matchName);
        }
      });

      updateCounts();
    }

    // Event Listeners para filtros
    $('#filter_role, #filter_dealer').on('change', applyFilters);
    $('#filter_name').on('input', applyFilters);

    // Adicionar selecionados
    $('#add_selected').on('click', function () {
      availableList.find('.user-checkbox-available:checked:visible').each(function () {
        const userItem = $(this).closest('.user-item');
        moveToSelected(userItem);
      });
    });

    // Adicionar todos filtrados
    $('#add_all_filtered').on('click', function () {
      availableList.children(':visible').each(function () {
        moveToSelected($(this));
      });
    });

    // Adicionar todos
    $('#add_all').on('click', function () {
      $('#filter_role, #filter_dealer, #filter_name').val('');
      availableList.children().each(function () {
        const item = $(this);
        if (!selectedUsers.has(item.data('user-id').toString())) {
          item.show();
          moveToSelected(item);
        }
      });
    });

    // Remover selecionados
    $('#remove_selected').on('click', function () {
      selectedList.find('.user-checkbox-selected:checked').each(function () {
        const userItem = $(this).closest('.user-item');
        moveToAvailable(userItem);
      });
      applyFilters();
    });

    // Remover todos
    $('#remove_all, #clear_selection').on('click', function () {
      selectedList.children().each(function () {
        moveToAvailable($(this));
      });
      applyFilters();
    });

    // Double click para mover
    availableList.on('dblclick', '.user-item', function () {
      if ($(this).is(':visible')) {
        moveToSelected($(this));
      }
    });

    selectedList.on('dblclick', '.user-item', function () {
      moveToAvailable($(this));
    });

    // Inicializa contadores
    updateCounts();
  }

  // ====================================
  // CONTROLE DE FREQUÊNCIA
  // ====================================

  $('#frequency_select').on('change', function () {
    $('.conditional-field').hide();

    const frequencyValue = $(this).val();
    console.log('Frequência selecionada:', frequencyValue);

    switch (String(frequencyValue)) {
      case 'weekly':
        $('#weekly_options').show();
        break;
      case 'monthly':
        $('#monthly_options').show();
        break;
      default:
        break;
    }
  }).trigger('change');

  // ====================================
  // CARREGAMENTO DE FILTROS
  // ====================================

  $('#model_source_select').on('change', function () {
    const model = $(this).val();
    if (model) {
      loadFiltersForModel(model);
      updateAvailableVariables(model);
    } else {
      $('#filters_container').html('<p class="text-muted">Selecione uma fonte de dados para configurar os filtros</p>');
    }
  });

  // Função para carregar filtros
  function loadFiltersForModel(model) {
    $('#filters_container').html('<div class="text-center"><i class="fa fa-spinner fa-spin"></i> Carregando filtros...</div>');

    // Pega o ID da notificação do formulário ou da URL
    let notificationId = '';

    // Tenta pegar do data attribute do formulário
    if ($('#notification_wa_form').length) {
      notificationId = $('#notification_wa_form').data('notification-id');
    }

    // Se não encontrou, tenta extrair da URL (para edição)
    if (!notificationId && window.location.pathname.match(/\/(\d+)\/edit/)) {
      notificationId = window.location.pathname.match(/\/(\d+)\/edit/)[1];
    }

    setTimeout(() => {
      $.ajax({
        url: '/notificacoes-wa/filter_fields',
        data: {
          model: model,
          id: notificationId // Sempre envia o ID se disponível
        },
        success: function (data) {
          $('#filters_container').html(data);

          // Inicializa componentes do formulário se necessário
          if ($.fn.select2) {
            $('#filters_container').find('.select2').select2({
              theme: 'bootstrap4',
              width: '100%'
            });
          }

          // Dispara evento personalizado para indicar que os filtros foram carregados
          $(document).trigger('filters:loaded', [model]);
        },
        error: function () {
          $('#filters_container').html(`<div class="alert alert-danger">Erro ao carregar filtros de: <strong>${model}</strong></div>`);
        }
      });
    }, 300);
  }

  // Atualiza variáveis disponíveis
  function updateAvailableVariables(model) {
    const modelVars = {
      'Lead': `
        <strong>Variáveis de Lead:</strong><br>
        <code>[new_leads]</code> - Novos leads<br>
        <code>[sources]</code> - Origens dos leads<br>
        <code>[total_by_status]</code> - Total por status<br>
        <code>[conversion_rate]</code> - Taxa de conversão<br>
        <code>[pending_followup]</code> - Aguardando follow-up`,
      'Attendance': `
        <strong>Variáveis de Atendimento:</strong><br>
        <code>[total_attendances]</code> - Total de atendimentos pendentes<br>
        <code>[attendances_list]</code> - Lista formatada dos atendimentos<br>
        <code>[over_limit_count]</code> - Quantidade acima do limite<br>
        <code>[action_required]</code> - Ação necessária<br>
        <code>[limit_hours]</code> - Limite de horas configurado<br>
        <code>[summary_by_dealer]</code> - Resumo por revenda`,
      'Evaluation': `
        <strong>Variáveis de Avaliação:</strong><br>
        <code>[total_evaluations]</code> - Total de avaliações sem precificação<br>
        <code>[evaluations_list]</code> - Lista formatada das avaliações<br>
        <code>[summary_by_dealer]</code> - Resumo agrupado por revenda<br>
        <code>[over_48h_count]</code> - Quantidade acima de 48 horas<br>
        <code>[action_required]</code> - Texto de ação necessária`
    };

    $('#model_specific_vars').html(modelVars[model] || '');
  }

  // ====================================
  // PREVIEW DA MENSAGEM
  // ====================================

  $('#notification_wa_message_template').on('keyup input', function () {
    const template = $(this).val();
    const modelSource = $('#model_source_select').val();

    // Preview com placeholders {{var}} ou [var]
    const replacements = {
      user_name: 'João Silva',
      date: new Date().toLocaleDateString('pt-BR'),
      status: 'Aguardando Atendimento',
      total_records: '15',
      total_attendances: '8',
      over_limit_count: '3',
      limit_hours: '2',
      summary: '📊 5 quentes, 8 mornos, 2 frios',
      hot_leads: '5 leads quentes',
      warm_leads: '8 leads mornos',
      cold_leads: '2 leads frios',
      pending_count: '8 pendentes',
      new_leads: '3 novos leads hoje',
      sources: 'Site: 10, WhatsApp: 5',
      attendances_list: `
1️⃣ Cliente: CLAUDIO SERGIO
ID: #120713 | Revenda: VIA PARIS MATRIZ
Vendedor: PAULO SOLDI
⏱️ Aguardando há: 46d23h46min (limite: 2h) ⚠️
🔗 https://siga.grupo4rodas.com.br/atendimentos/120713

2️⃣ Cliente: FRANCINETE ARAUJO DE CASTRO
ID: #120715 | Revenda: VIA PARIS MATRIZ
Vendedor: PAULO SOLDI
⏱️ Aguardando há: 46d23h33min (limite: 2h) ⚠️
🔗 https://siga.grupo4rodas.com.br/atendimentos/120715`,
      action_required: '⚡ Ação necessária: Iniciar atendimento imediatamente',
      summary_by_dealer: '• Revenda A: 3 atendimentos\n• Revenda B: 5 atendimentos'
    };

    function applyPlaceholders(str, map) {
      for (const [key, val] of Object.entries(map)) {
        const re = new RegExp(`({{\\s*${key}\\s*}}|\\[\\s*${key}\\s*\\])`, 'gi');
        str = str.replace(re, val);
      }
      return str;
    }

    let preview = applyPlaceholders(template, replacements);

    // Se for Attendance e não houver placeholders, mostra preview automático
    const hasPlaceholders = /({{\s*[\w.]+\s*}}|\[\s*[\w.]+\s*\])/.test(template);
    if (modelSource === 'Attendance' && !hasPlaceholders) {
      preview = '🚨 ALERTA - OPERADOR DE MARCA\n📊 Total de Pendências: 8\n\n' +
        '━━━━━━━━━━━━━━━━━━━━━━━━\n' +
        '⏳ AGUARDANDO ATENDIMENTO\n' +
        '━━━━━━━━━━━━━━━━━━━━━━━━\n\n' +
        '(Lista formatada de atendimentos será gerada automaticamente)';
    }

    if ($('#message_preview').length === 0) {
      $(this).after(
        '<div id="message_preview" class="alert alert-secondary mt-2 px-0 mb-0 pb-0">' +
        '<strong>Preview:</strong><br>' +
        '<pre v-pre style="white-space: pre-wrap;" class="mb-0"></pre>' +
        '</div>'
      );
    }

    $('#message_preview pre').text(preview);
  });

  // Preview dinâmico via AJAX
  $(document).on('click', '#preview_message_btn', function (e) {
    e.preventDefault();
    const link = $(this).data('link');

    if (!link) {
      console.error('Link para preview não encontrado');
      return;
    }

    // Mostra loading no preview
    $('#message_preview_content pre').text('Carregando preview...');

    $.get(link, function (data) {
      if (data.rendered_message) {
        $('#message_preview_content pre').text(data.rendered_message);
      } else if (data.error) {
        $('#message_preview_content pre').text('Erro ao gerar preview: ' + data.message);
      }
    }).fail(function (xhr) {
      console.error('Erro ao buscar preview:', xhr);
      $('#message_preview_content pre').text('Erro ao carregar preview. Verifique o console.');
    });
  });

  // ====================================
  // SALVAR E TESTAR
  // ====================================

  $('#save_and_test').on('click', function (e) {
    e.preventDefault();
    const $form = $(this).closest('form');

    // Remove input anterior se existir
    $form.find('input[name="test_after_save"]').remove();

    // Adiciona novo input
    $form.append('<input type="hidden" name="test_after_save" value="true">');
    $form.submit();
  });

  // ====================================
  // VALIDAÇÃO DO FORMULÁRIO
  // ====================================

  $('form[id*="notification_wa_form"]').on('submit', function (e) {
    // Valida usuários selecionados
    const selectedCount = $('#user_ids_select option:selected').length;

    if (selectedCount === 0) {
      if (!confirm('Nenhum usuário selecionado. Deseja continuar mesmo assim?')) {
        e.preventDefault();
        return false;
      }
    }

    // Valida campos obrigatórios
    const name = $('#notification_wa_name').val();
    const template = $('#notification_wa_message_template').val();
    const model = $('#model_source_select').val();
    const sendTime = $('#notification_wa_send_time').val();

    if (!name || !template || !model || !sendTime) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      e.preventDefault();
      return false;
    }

    // Valida frequência semanal
    if ($('#frequency_select').val() === 'weekly') {
      if (!$('#notification_wa_day_of_week').val()) {
        alert('Por favor, selecione o dia da semana para envio.');
        e.preventDefault();
        return false;
      }
    }

    // Valida frequência mensal
    if ($('#frequency_select').val() === 'monthly') {
      const dayOfMonth = $('#notification_wa_day_of_month').val();
      if (!dayOfMonth || dayOfMonth < 1 || dayOfMonth > 31) {
        alert('Por favor, informe um dia válido do mês (1-31).');
        e.preventDefault();
        return false;
      }
    }
  });

  // ====================================
  // TOOLTIPS E HELPERS
  // ====================================

  // Inicializa tooltips se existir Bootstrap tooltip
  if ($.fn.tooltip) {
    $('[data-toggle="tooltip"]').tooltip();
  }

  // Adiciona indicador de campo obrigatório
  $('input[required], select[required], textarea[required]').each(function () {
    const label = $(this).closest('.form-group').find('label').first();
    if (label.length && !label.find('.required-indicator').length) {
      label.append(' <span class="required-indicator text-danger">*</span>');
    }
  });

  // ====================================
  // INICIALIZAÇÃO PARA MODO EDIÇÃO
  // ====================================

  // Verifica se está em modo de edição
  const isEditMode = window.location.pathname.includes('/edit');

  if (isEditMode) {
    // Aguarda um momento para garantir que o DOM está pronto
    setTimeout(() => {
      // Trigger do modelo se já tiver valor (modo edit)
      const modelValue = $('#model_source_select').val();
      if (modelValue) {
        $('#model_source_select').trigger('change');
      }

      // Trigger do preview se já tiver texto
      if ($('#notification_wa_message_template').val()) {
        $('#notification_wa_message_template').trigger('keyup');
      }
    }, 100);
  } else {
    // Modo criação - inicializa normalmente
    if ($('#model_source_select').val()) {
      $('#model_source_select').trigger('change');
    }
  }

  // Listener para quando os filtros são carregados
  $(document).on('filters:loaded', function (e, model) {
    console.log('Filtros carregados para o modelo:', model);

    // Aqui você pode adicionar lógica adicional após os filtros serem carregados
    // Por exemplo, inicializar componentes específicos do modelo
  });

  // ====================================
  // TEST STATUS (show)
  // ====================================
  (function setupTestStatus() {
    let $card = $('#test-status-card');
    if (!$card.length) return;

    let url = $card.data('status-url');
    let runId = $card.data('run-id');
    if (runId) {
      url += (url.indexOf('?') >= 0 ? '&' : '?') + 'run_id=' + encodeURIComponent(runId);
    }
    let poll = null, bootTicks = 15;

    let $state = $('#ts-state');
    let $bar = $('#ts-progress');
    let $proc = $('#ts-processed');
    let $total = $('#ts-total');
    let $ok = $('#ts-success');
    let $fail = $('#ts-failed');
    let $skip = $('#ts-skipped');
    let $eta = $('#ts-eta');

    function fmtSecs(s) {
      if (s == null) return '';
      let m = Math.floor(s / 60), r = s % 60;
      return (m ? (m + 'm ') : '') + r + 's';
    }

    function paint(d) {
      $card.removeClass('d-none');
      $total.text(d.total);
      $proc.text(d.processed);
      $ok.text(d.success);
      $fail.text(d.failed);
      $skip.text(d.skipped);

      $bar.css('width', d.percent + '%').attr('aria-valuenow', d.percent);

      if (d.status === 'running') {
        $state.attr('class', 'badge badge-info').text('Processando...');
        $eta.text(d.eta_seconds ? ('ETA ~ ' + fmtSecs(d.eta_seconds)) : '');
      } else if (d.status === 'done') {
        $state.attr('class', 'badge badge-success').text('Concluído');
        $eta.text('');
      } else {
        $state.attr('class', 'badge badge-secondary').text('Aguardando');
        $eta.text('');
      }
    }

    function tick() {
      $.getJSON(url)
        .done(function (d) {
          paint(d);
          if (d.status === 'done') { stop(); }
          if (d.status === 'idle' && d.processed === 0 && --bootTicks <= 0) { stop(); }
        })
        .fail(function () { /* silencioso */ });
    }

    function start() {
      if (poll) return;
      tick();
      poll = setInterval(tick, 2000);
    }

    function stop() {
      if (poll) { clearInterval(poll); poll = null; }
    }

    start();

    $('#btn-test-send, a[href$="/test_send"]').on('click', function () {
      start();
    });

    document.addEventListener('turbolinks:before-cache', stop);
  })();

  // ====================================
  // GERENCIAMENTO DE LOGS
  // ====================================

  const selectAllCheckbox = $('#select_all_logs');
  const logCheckboxes = $('.log-checkbox');
  const deleteSelectedBtn = $('#delete_selected_logs');
  const selectedCountSpan = $('#selected_count');
  const bulkDeleteForm = $('#bulk_delete_form');

  if (selectAllCheckbox.length && logCheckboxes.length) {

    // Função para atualizar contador e estado dos botões
    function updateLogSelectionState() {
      const checkedBoxes = $('.log-checkbox:checked');
      const count = checkedBoxes.length;

      selectedCountSpan.text(count);
      deleteSelectedBtn.prop('disabled', count === 0);

      // Atualizar estado do "selecionar todos"
      if (count === 0) {
        selectAllCheckbox.prop('checked', false);
        selectAllCheckbox.prop('indeterminate', false);
      } else if (count === logCheckboxes.length) {
        selectAllCheckbox.prop('checked', true);
        selectAllCheckbox.prop('indeterminate', false);
      } else {
        selectAllCheckbox.prop('checked', false);
        selectAllCheckbox.prop('indeterminate', true);
      }
    }

    // Selecionar/desselecionar todos
    selectAllCheckbox.on('change', function () {
      const isChecked = $(this).prop('checked');
      logCheckboxes.prop('checked', isChecked);
      updateLogSelectionState();
    });

    // Atualizar ao marcar/desmarcar individual
    logCheckboxes.on('change', updateLogSelectionState);

    // Excluir selecionados
    deleteSelectedBtn.on('click', function () {
      const checkedBoxes = $('.log-checkbox:checked');
      const count = checkedBoxes.length;

      if (count === 0) return;

      const confirmMessage = `Tem certeza que deseja excluir ${count} log(s) selecionado(s)?\n\nEsta ação não pode ser desfeita!`;

      if (confirm(confirmMessage)) {
        bulkDeleteForm.submit();
      }
    });

    // Estado inicial
    updateLogSelectionState();
  }
};

// Inicializa quando o DOM estiver pronto
export default domReady(initNotificationsWa);